// The count of opening moves due, on the Openings tab: kept in step without
// making a fuss about it.

import { getJson } from "./api.ts";

let checkedAt = 0;

export function setDrillBadge(due: number): void {
  for (const el of document.querySelectorAll<HTMLElement>("[data-badge='openings']")) {
    el.textContent = due > 99 ? "99+" : String(due || "");
    el.hidden = !due;
  }
}

export function refreshDrillBadge(force = false): void {
  if (!force && Date.now() - checkedAt < 30_000) return;
  checkedAt = Date.now();
  getJson<{ due?: number }>("/api/repertoires")
    .then((data) => setDrillBadge(data.due || 0))
    .catch(() => {});
}
